import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';

import {goToPage, reportAnalytics, setCellularPackage} from '../saleBlockSlice';
import CellularPackageHolder from '../CellularPackageHolder/CellularPackageHolder';

const CellularPackagesPage = (props) => {
  let flowType = props.flowType;

  useEffect(() => {

  }, []);

  //page params
  let isDisplayFooter = false;
  let btnText = '';
  let currentPageFunction = handleCellularPackagesContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'sale';
  let titleText = `בחירת חבילת סלולר למספר ${(props.productsInfo.selectedProducts.length + 1)}`;

  let productsForUpgrade = props.productsInfo.listProductsForUpgrade;
  const filteredProducts = productsForUpgrade?.filter(x=> !!x.isDisplaySimActivation.value == props.productsInfo.baseProduct.isDisplaySimActivation);
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title-big'> {titleText} </h1>
    </div>
  );

  let currentPageView = (
    <CellularPackageHolder products={filteredProducts} onSelected={handleCellularPackagesContinue} />
  );

  function handleCellularPackagesContinue(productId) {
    props.setCellularPackage(productId);
    props.goToPage({page: 'chooseNumberPage', percent: 10});
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content full-width'>
        {currentPageView}
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    productsInfo: state.saleBlock.productsInfo,
    infrastructure: state.saleBlock.selectedAddress.infrastructure,

    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setCellularPackage
};

export default connect(mapStateToProps, mapDispatchToProps)(CellularPackagesPage);
